module.exports = __webpack_public_path__ + "media/images/bg-demo-tests-1d53d150f22f2730a388ba0c12b51f4d.png";